// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2SQYh","itemTitle":"ClientEmergencyInfo_itemTitle__1ABpP","itemText":"ClientEmergencyInfo_itemText__3vb6O"};